module.exports = __webpack_public_path__ + "img/0966379.jpg";